import { useState } from "react";
import { fmtCHF, unitShort } from "../utils";

export default function ArticleAdder({ articles, setArticles, prices, prefix }) {
  const [sel, setSel] = useState("");
  const add = () => {
    const p = prices.find((x) => x.id === sel);
    if (!p) return;
    setArticles([...(articles || []), { name: p.name, qty: 1, unit_price: p.price, unit: p.unit }]);
    setSel("");
  };
  return (
    <div className="flex gap-2">
      <select data-testid={`${prefix}-article-select`} value={sel} onChange={(e) => setSel(e.target.value)}
        className="flex-1 rounded-lg border border-slate-300 px-2 py-1.5 text-sm bg-white">
        <option value="">— Ajouter un article —</option>
        {prices.map((p) => (
          <option key={p.id} value={p.id}>{p.name} ({fmtCHF(p.price)} / {unitShort(p.unit)})</option>
        ))}
      </select>
      <button type="button" data-testid={`${prefix}-article-add`} onClick={add}
        className="px-3 py-1.5 rounded-lg bg-sky-600 text-white text-sm font-semibold hover:bg-sky-700 transition-colors">+</button>
    </div>
  );
}

export function ArticleRows({ articles, setArticles, prefix }) {
  return (
    <>
      {(articles || []).map((a, i) => (
        <div key={i} className="flex items-center gap-2" data-testid={`${prefix}-article-row-${i}`}>
          <span className="flex-1 text-sm text-slate-800 min-w-0 truncate">
            {a.name} <span className="text-xs text-slate-400">({fmtCHF(a.unit_price)} / {unitShort(a.unit)})</span>
          </span>
          <input data-testid={`${prefix}-article-qty-${i}`} type="number" step="0.1" min="0" value={a.qty}
            onChange={(e) => { const arts = [...articles]; arts[i] = { ...a, qty: parseFloat(e.target.value) || 0 }; setArticles(arts); }}
            className="w-20 rounded-lg border border-slate-300 px-2 py-1.5 text-sm" />
          <button type="button" data-testid={`${prefix}-article-del-${i}`}
            onClick={() => setArticles(articles.filter((_, j) => j !== i))}
            className="text-slate-400 hover:text-red-600 text-lg leading-none px-1">×</button>
        </div>
      ))}
    </>
  );
}
